<template>
  <div class="search-property flex">
    <div class="search-property__title">
      <slot name="title"></slot>
    </div>
    <div class="search-property__value">
      <slot name="value"></slot>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
